import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { InadimplenciaTecnica } from "src/app/model/inadimplencia-tecnica.model";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
})
export class InadimplenciaService extends FgiBackEndService<InadimplenciaTecnica>{

    getNewEntity(): InadimplenciaTecnica {
        const model = new InadimplenciaTecnica();
        model.dataInsercao = new Date();
        return model;
    }

    protected getResourceURL(): string {
        return 'front/inadimplencias-tecnicas';
    }

    getInadimplenciasTecnicas(params?: any): any{
        return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<InadimplenciaTecnica>>;
    }

    excluir(id: number): any{
      const options = blockUi();
        return this.http.post(`${this.BASE_URL}/${id}`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<InadimplenciaTecnica>>;
    }
}
